module.exports = __webpack_public_path__ + "static/img/bg.216d7b5e.jpg";